import { AxiosPromise } from 'axios';

import { vaultApi } from '../api';
import { IApiResponse } from '../interfaces';
import { IUserPermissions } from './interfaces';

const basePath = '/userPermissions';

/* eslint-disable implicit-arrow-linebreak */

export const getUserPermissions = (): AxiosPromise<IApiResponse<IUserPermissions>> => vaultApi.getInstance().get(`${basePath}/loggedInUser`);
